const request = {
    message_rate_limited: 'Bu alıcıya çok fazla mesaj gönderildi. Lütfen daha sonra yeniden deneyin.',
    invalid_input: 'Girdi geçersiz. {{details}}',
    general: 'İstek hatası oluştu.',
    range_not_satisfiable: 'Aralık karşılanamıyor.',
    feature_not_supported: 'Bu özellik mevcut ortamda desteklenmiyor.',
    rate_limited: 'Çok fazla istek. Lütfen daha sonra tekrar deneyin.',
};
export default Object.freeze(request);
